<eff-popup-header [title]="data.title" [dialogRef]="dialogRef"></eff-popup-header>
<div class="dialog-body">
    <app-eff-textarea-field
        class="grid-textarea-style"
        [(model)]="data.text"
        [disabled]="!data.editAllowed"
        uiid="popup"
        data-uiid="eff-comment-popup-textarea"
    ></app-eff-textarea-field>
</div>

<div class="dialog-footer">
    @if (data.cancelButton) {
        <eff-button
            size="medium-size"
            class="cancel-button"
            [text]="data.cancelButton"
            (click)="cancel()"
            data-uiid="eff-comment-popup-cancel-button"
        ></eff-button>
    }
    @if (data.editAllowed) {
        <eff-button
            class="confirm-comment-button"
            [text]="data.confirmButton"
            (click)="confirm()"
            data-uiid="eff-comment-popup-confirm-button"
        ></eff-button>
    }
</div>
